/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable array-callback-return */
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { DatePicker, FormInstance } from 'antd';
import { RuleObject } from 'antd/lib/form';
import { isArray } from 'lodash';
import { useCallback, useEffect, useReducer, useState } from 'react';
import { useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Button from '../../components/Button';
import Form from '../../components/Form';
import FormInput from '../../components/FormInput';
import Select from '../../components/Select';
import {
  FilterFieldProps,
  useGetAllFilterCollectionsQuery,
  useGetAllFilterFieldCategoryQuery,
} from '../../services/filterFieldCategory';
import { Body } from '../../styles/fonts';
import fieldsMaxMin from '../FilterMap/Filters/fields_max_min.json';
import { dynamicOptions } from './constants/dynamicOptions';
import { Body2, Filter02, IconWrapper, OrAnd01, OrAnd01None } from './styles';

const FIELDNAME_ALIASES: Record<string, string> = {
  E_BRINDE: 'E_BRINDE',
  '"EnrichedContact"."Gift"': 'E_BRINDE',
  E_CONVENIENCIA: 'E_CONVENIENCIA',
  '"EnrichedContact"."Convenience"': 'E_CONVENIENCIA',
  E_CONFIANCA_DE_MARCA: 'E_CONFIANCA_DE_MARCA',
  '"EnrichedContact"."BrandTrust"': 'E_CONFIANCA_DE_MARCA',
  E_VAREJO_FISICO: 'E_VAREJO_FISICO',
  '"EnrichedContact"."PhysicalRetail"': 'E_VAREJO_FISICO',
  E_VALOR_SAZONAL: 'E_VALOR_SAZONAL',
  '"EnrichedContact"."SeasonalValue"': 'E_VALOR_SAZONAL',
  E_INSTABILIDADE: 'E_INSTABILIDADE',
  '"EnrichedContact"."Instability"': 'E_INSTABILIDADE',
  E_INOVACAO: 'E_INOVACAO',
  '"EnrichedContact"."Innovation"': 'E_INOVACAO',
  E_INFLUENCIA_CONSUMO_OFFLINE: 'E_INFLUENCIA_CONSUMO_OFFLINE',
  '"EnrichedContact"."InfluenceOfflineConsumption"':
    'E_INFLUENCIA_CONSUMO_OFFLINE',
  E_INFLUENCIA_CONSUMO_ONLINE: 'E_INFLUENCIA_CONSUMO_ONLINE',
  '"EnrichedContact"."InfluenceOnlineConsumption"':
    'E_INFLUENCIA_CONSUMO_ONLINE',
  E_ESTABILIDADE: 'E_ESTABILIDADE',
  '"EnrichedContact"."Stability"': 'E_ESTABILIDADE',
  E_FACILIDADE_DE_PAGAMENTO: 'E_FACILIDADE_DE_PAGAMENTO',
  '"EnrichedContact"."EaseOfPayment"': 'E_FACILIDADE_DE_PAGAMENTO',
  E_CUSTO_BENEFICIO: 'E_CUSTO_BENEFICIO',
  '"EnrichedContact"."CostBenefit"': 'E_CUSTO_BENEFICIO',
  E_CONSUMO_POTENCIAL_DIGITAL: 'E_CONSUMO_POTENCIAL_DIGITAL',
  '"EnrichedContact"."DigitalConsumptionPotential"':
    'E_CONSUMO_POTENCIAL_DIGITAL',
  E_ESG: 'E_ESG',
  '"EnrichedContact"."Esg"': 'E_ESG',
  E_STATUS_SOCIAL: 'E_STATUS_SOCIAL',
  '"EnrichedContact"."SocialStatus"': 'E_STATUS_SOCIAL',
  E_EXPERIENCIA_DE_COMPRA: 'E_EXPERIENCIA_DE_COMPRA',
  '"EnrichedContact"."ShoppingExperience"': 'E_EXPERIENCIA_DE_COMPRA',
  E_OPCAO_PAG: 'E_OPCAO_PAG',
  '"EnrichedContact"."PagOption"': 'E_OPCAO_PAG',
  E_PREMIUM: 'E_PREMIUM',
  '"EnrichedContact"."Premium"': 'E_PREMIUM',
  E_PREMIUM_SERVICO: 'E_PREMIUM_SERVICO',
  '"EnrichedContact"."PremiumService"': 'E_PREMIUM_SERVICO',
  E_VANTAGEM_ECONOMICA: 'E_VANTAGEM_ECONOMICA',
  '"EnrichedContact"."EconomicAdvantage"': 'E_VANTAGEM_ECONOMICA',
};

interface Teste {
  group: any;
  formInstance: FormInstance<any>;
  groupOrder: 'row' | 'column';
  origin: string;
  hasSegmentatioAnalysisTab: boolean;
}

function orderListByKey(data: any, key: string, order?: string) {
  const compareValues =
    (key: string, order = 'asc') =>
    (elemA: any, elemB: any) => {
      // eslint-disable-next-line no-prototype-builtins
      if (!elemA.hasOwnProperty(key) || !elemB.hasOwnProperty(key)) return 0;
      const comparison = elemA[key].localeCompare(elemB[key]);
      return order === 'desc' ? comparison * -1 : comparison;
    };
  return data?.sort(compareValues(key, order));
}

const Query = ({
  group,
  formInstance,
  groupOrder,
  origin,
  hasSegmentatioAnalysisTab,
}: Teste) => {
  const [filter, setFilter] = useState<any[]>([]);
  const [subFilter, setSubFilter] = useState<FilterFieldProps[]>([]);
  const allValues = Form.useWatch([], formInstance);

  const { id } = useParams();

  const [flagUpdate, setFlagUpdate] = useState<boolean>(false);

  const [currentGroupAndQuery, setCurrentGroupAndQuery] = useState<any>({});

  const [odataName, setOdataName] = useState<string>('');

  const [operatorId, setOperatorId] = useState<string>('');

  const [, forceUpdate] = useReducer(x => x + 1, 2);

  const { data: filterFields } = useGetAllFilterFieldCategoryQuery({ origin });

  const {
    currentData: filterCollections,
    refetch,
    isSuccess,
  } = useGetAllFilterCollectionsQuery(
    {
      nameControllerOdata: odataName,
    },
    {
      skip: odataName === 'Boolean',
    },
  );

  const handleChangeOperator = (
    groupName: any,
    field: any,
    filterCollection: any,
  ) => {
    console.log('filterCollection: ', filterCollection);
    const t = filter;

    const atual = t.find(a => a.group === groupName);

    if (atual) {
      if (atual.filters[field]) {
        atual.filters[field].options = [...filterCollection?.data];
      }

      const prev2 = [...t];
      prev2[t.findIndex(a => a.group === groupName)] = atual;

      setFilter(prev2);
    }
  };

  const handleChangeOperatorInput = (e: string) => {
    forceUpdate();
    setOperatorId(e);
  };

  useEffect(() => {
    if (filterCollections && currentGroupAndQuery) {
      handleChangeOperator(
        currentGroupAndQuery?.group?.name,
        currentGroupAndQuery?.field?.name,
        filterCollections,
      );
    }
  }, [filterCollections, currentGroupAndQuery]);

  useEffect(() => {
    const subFilters: any = [];
    if (filterFields) {
      filterFields?.map(t => {
        t.filterFields.map((fil: any) => {
          return subFilters.push(fil);
        });
      });
      setSubFilter(subFilters);
    }
  }, [filterFields]);

  const handleChange = (groupName: string, e: any, index: any) => {
    const newFilter = subFilter.find(a => a.id === e);
    const currentGroup = filter.find(a => a.group === groupName);

    const filterKey = uuidv4();

    const fields = formInstance.getFieldsValue();
    const { groups } = fields;

    Object.assign(groups[group.name]?.filtersDefinition[index], {
      filterKey,
      origin:
        newFilter?.filterFieldCategoryId ===
        '733c01a1-983a-43eb-a214-fd7e0d44f14b'
          ? 'CustomField'
          : 'FilterField',
    });

    formInstance.setFieldsValue({ groups });

    const filterInUse = currentGroup?.filters[index];
    if (filterInUse) {
      const u = filter.map(fil => {
        const filCopy = Object.assign(fil);
        filCopy.filters = fil.filters.map((f: any, i: number) => {
          if (i === index) {
            return { ...newFilter, options: undefined, filterKey };
          }
          return f;
        });
        filCopy.group = groupName;
        return filCopy;
      });
      setFilter(u);
      return;
    }

    if (!currentGroup) {
      setFilter(prev => [
        ...prev,
        {
          group: groupName,
          filters: [{ ...newFilter, options: undefined, filterKey }],
        } as any,
      ]);
    } else {
      setFilter(prev => {
        const atual = prev.find(a => a.group === groupName);

        atual.filters = [
          ...prev.find(a => a.group === groupName).filters,
          { ...newFilter, options: undefined, filterKey },
        ];
        const prev2 = [...prev];
        prev2[prev.findIndex(a => a.group === groupName)] = atual;
        return prev2;
      });
    }
    setFlagUpdate(true);
  };

  const genericListSelectInputPotentialAudiency = [
    {
      key: 'e1391998-a637-41af-b2f9-f117dd4b00ca',
      name: 'E',
    },
  ];

  const genericListSelectInputAnalysisSegmentation = [
    {
      key: '07174c20-607e-46cd-b7ac-1903f3d378ed',
      name: 'E',
    },
  ];

  const genericListSelector = hasSegmentatioAnalysisTab
    ? genericListSelectInputAnalysisSegmentation
    : genericListSelectInputPotentialAudiency;

  const emptyOperators = [
    '3313266f-1888-4c5a-8dfc-2c2ac1479d12',
    '89a6ad41-683e-40a3-9480-dcbb9e61a516',
    '98e71be4-fb73-44e5-8f64-4d606e377858',
    'f641ae32-a99f-4844-86fd-b906d4a12b63',
  ];

  const getFilterValue = useCallback(
    (group: any, field: any, key: any, valuePos: any) => {
      const foo = formInstance.getFieldsValue(['groups'])?.groups[group?.name]
        ?.filtersDefinition[field.name]?.[key];

      const assertFilterOperatorId = formInstance.getFieldsValue(['groups'])
        ?.groups[group?.name]?.filtersDefinition[field.name]
        ?.assertFilterOperatorId;

      console.log(
        'isArray',
        assertFilterOperatorId,
        formInstance.getFieldsValue(['groups'])?.groups[group?.name]
          ?.filtersDefinition[field.name]?.[key],
        foo?.[0],
        foo?.[1],
        Array.isArray(foo),
        isArray(foo),
        foo,
        formInstance.getFieldsValue(['groups'])?.groups,
        formInstance.getFieldsValue(['groups'])?.groups[group?.name]
          ?.filtersDefinition[field.name]?.[key]?.[valuePos],
        formInstance.getFieldsValue(['groups'])?.groups[group?.name]
          ?.filtersDefinition[field.name]?.[key],
      );

      // trocar para o entre
      if (
        assertFilterOperatorId === 'd6697357-f63f-4e8a-a198-fccafbb2c52e' &&
        isArray(foo)
      ) {
        console.log('isArray');
        return formInstance.getFieldsValue(['groups'])?.groups[group?.name]
          ?.filtersDefinition[field.name]?.[key]?.[valuePos];
      }
      return formInstance.getFieldsValue(['groups'])?.groups[group?.name]
        ?.filtersDefinition[field.name]?.[key];
    },
    [formInstance],
  );

  const getValue = useCallback(
    (group: any, field: any, key: any) => {
      return formInstance.getFieldsValue(['groups'])?.groups[group?.name]
        ?.filtersDefinition[field.name]?.[key];
    },
    [formInstance],
  );

  console.log(formInstance.getFieldsValue(), 'formInstance.getFieldsValue');

  const handleSelectOperator = async (
    filterId: string,
    group: any,
    field: any,
  ) => {
    console.log('subFilter: ', subFilter);
    const filterSelect = subFilter.find(a => a.id === filterId);
    const fields = formInstance.getFieldsValue();
    const { groups } = fields;

    Object.assign(groups[group.name]?.filtersDefinition[field.name], {
      filterValue: id
        ? await getFilterValue(group, field, 'filterValue', 0)
        : undefined,
      filterValue2: id
        ? await getFilterValue(group, field, 'filterValue', 1)
        : undefined,
    });

    formInstance.setFieldsValue({ groups });

    const selectedOptions = dynamicOptions.find(option => {
      return filterSelect?.id
        ? option.idCollection.includes(filterSelect.id)
        : false;
    })?.data;
    if (selectedOptions) {
      setFilter(prevFilters => {
        const groupData = prevFilters.find(f => f.group === group.name) || {
          group: group.name,
          filters: [],
        };

        const filterIndex = groupData.filters.findIndex(
          (f: any) => f.filterKey === field.name && f.id === filterSelect?.id,
        );

        if (filterIndex >= 0) {
          groupData.filters[filterIndex].options = selectedOptions;
        } else {
          groupData.filters.push({
            ...field,
            filterKey: field.name,
            id: filterSelect?.id,
            options: selectedOptions,
          });
        }

        return [...prevFilters.filter(f => f.group !== group.name), groupData];
      });

      setFlagUpdate(true);
    } else if (filterSelect?.collectionType) {
      setCurrentGroupAndQuery({ group, field });
      setOdataName(filterSelect?.collectionType?.name);
      refetch();
    }

    forceUpdate();
  };

  const handleRemoveQuery = (
    remove: any,
    fieldname: any,

    filterKey: any,
  ) => {
    const finalFilter = filter[0].filters.filter(
      (a: any) => a.filterKey !== filterKey,
    );

    const fields = formInstance.getFieldsValue();
    const { groups } = fields;

    if (groups[group.name]?.filtersDefinition.length > fieldname + 1) {
      Object.assign(groups[group.name]?.filtersDefinition[fieldname + 1], {
        joinFilterOperatorId: null,
      });
    }

    formInstance.setFieldsValue({ groups });

    const filterCopy = Object.assign(filter);
    filterCopy[0].filters = finalFilter;

    remove(fieldname);
    setFilter([...filterCopy]);
    forceUpdate();
  };

  const isBeetwenConnector = (group: any, field: any) => {
    const connector = filter?.find((a: any) => a.group === group.name)?.filters[
      field.name
    ]?.componentType;

    console.log('isBeetwenConnector', connector);

    return connector === 'Beetwen';
  };

  const validateFields = (
    _: RuleObject,
    values: { field1: any; field2: any },
  ) => {
    console.log(values, 'validateFields');
    const { field1, field2 } = values;
    if (field1 && field2 && field2 > field1) {
      return Promise.resolve();
    }

    return Promise.reject(
      new Error('A idade desse campo deve ser maior que o anterior'),
    );
  };

  function getMinMaxByField(fieldName: string) {
    if (!fieldName) return {};
    const alias = FIELDNAME_ALIASES[fieldName] || fieldName;
    const keyBase = alias
      .replace(/ /g, '_')
      .normalize('NFD')
      .replace(/\u0300-\u036f]/g, '')
      .toUpperCase();
    const min = (fieldsMaxMin as any)[`${keyBase}_min`]?.value;
    const max = (fieldsMaxMin as any)[`${keyBase}_max`]?.value;
    console.log(
      '[MINMAX] fieldName:',
      fieldName,
      '| alias:',
      alias,
      '| keyBase:',
      keyBase,
      '| min:',
      min,
      '| max:',
      max,
    );
    return { min, max };
  }

  const handleField = (groupName: any, fieldName: any) => {
    const filterItem = filter?.find((a: any) => a.group === groupName)?.filters[
      fieldName
    ];
    console.log('filterItem: ', filterItem);
    const selectedOptions = dynamicOptions.find(option =>
      option.idCollection.includes(filterItem?.id),
    )?.data;
    console.log('selectedOptions: ', selectedOptions);
    console.log(
      filter?.find((a: any) => a.group === groupName)?.filters[fieldName]
        ?.componentType,
    );
    switch (
      filter?.find((a: any) => a.group === groupName)?.filters[fieldName]
        ?.componentType
    ) {
      case 'InputText':
        return (
          <FormInput
            disabled={emptyOperators.includes(
              formInstance.getFieldValue('groups')[groupName].filtersDefinition[
                fieldName
              ].assertFilterOperatorId,
            )}
          />
        );
      case 'DatePicker':
        return (
          <DatePicker
            style={{ width: '100%' }}
            format="DD-MM-YYYY"
            disabled={emptyOperators.includes(
              formInstance.getFieldValue('groups')[groupName].filtersDefinition[
                fieldName
              ].assertFilterOperatorId,
            )}
          />
        );
      case 'InputNumber':
        return (
          <FormInput.Number
            disabled={emptyOperators.includes(
              formInstance.getFieldValue('groups')[groupName].filtersDefinition[
                fieldName
              ].assertFilterOperatorId,
            )}
          />
        );

      case 'SelectMultiple':
        return (
          <Select
            mode="multiple"
            optionFilterProp="children"
            disabled={emptyOperators.includes(
              formInstance.getFieldValue('groups')[groupName].filtersDefinition[
                fieldName
              ].assertFilterOperatorId,
            )}
            filterOption={(input, option) => {
              if (
                [
                  'cbe4d356-bd28-4d50-996c-8ff3c7bf271e',
                  '018da355-4451-408f-a078-c4728b1a5d6d',
                ].includes(filterItem?.id)
              ) {
                const searchValue = input.replace(/-/g, '');
                return Boolean(
                  option?.value
                    ?.toString()
                    .toLowerCase()
                    .includes(searchValue.toLowerCase()) ||
                    option?.children
                      ?.toString()
                      .toLowerCase()
                      .includes(searchValue.toLowerCase()),
                );
              }
              return Boolean(
                option?.children
                  ?.toString()
                  .toLowerCase()
                  .includes(input.toLowerCase()),
              );
            }}
          >
            {selectedOptions
              ? selectedOptions.map((option: any) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))
              : odataName !== 'Boolean' &&
                orderListByKey(
                  filter?.find((a: any) => a.group === groupName).filters[
                    fieldName
                  ]?.options,
                  'name',
                )?.map((filterCol: any) => {
                  return (
                    <Select.Option
                      key={filterCol.id}
                      value={filterCol.rawName || filterCol.id}
                    >
                      {filterCol.name || filterCol.customerFileName}
                    </Select.Option>
                  );
                })}

            {odataName === 'Boolean' && (
              <>
                <Select.Option key="true" value="true">
                  Sim
                </Select.Option>
                <Select.Option key="false" value="false">
                  Não
                </Select.Option>
              </>
            )}
          </Select>
        );

      case 'Beetwen':
        return <FormInput.Number />;
      default:
        break;
    }
  };

  return (
    <Body2>
      <Form.List
        name={[group.name, 'filtersDefinition']}
        initialValue={[{ originFilterFieldId: undefined }]}
      >
        {(query, { add, remove }) => {
          return (
            <>
              {query.map((field: any) => {
                const fieldOperatorValue =
                  allValues?.groups[group.name]?.filtersDefinition[1]
                    ?.joinFilterOperatorId;
                if (subFilter.length > 0 && !flagUpdate) {
                  handleChange(
                    group.name,
                    getValue(group, field, 'originFilterFieldId'),
                    field.name,
                  );

                  handleSelectOperator(
                    getValue(group, field, 'originFilterFieldId'),
                    group,
                    field,
                  );
                }

                return (
                  <>
                    {query.length > 1 && field.name > 0 && (
                      <OrAnd01None>
                        <OrAnd01>
                          <Form.Item
                            name={[field.name, 'joinFilterOperatorId']}
                            fieldKey={[field.fieldKey, 'joinFilterOperatorId']}
                            rules={[{ required: true }]}
                            initialValue={genericListSelector[0].key}
                          >
                            <Select>
                              {genericListSelector.map(item => (
                                <Select.Option key={item.key} value={item.key}>
                                  {item.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </OrAnd01>
                      </OrAnd01None>
                    )}
                    <Filter02
                      style={{
                        flexDirection: groupOrder === 'row' ? 'row' : 'column',
                      }}
                    >
                      <Form.Item
                        name={[field.name, 'originFilterFieldId']}
                        fieldKey={[field.fieldKey, 'originFilterFieldId']}
                        style={{
                          width: groupOrder === 'row' ? '33.33%' : '100%',
                        }}
                        rules={[{ required: true }]}
                      >
                        <Select
                          onChange={e => {
                            handleChange(group.name, e, field.name);
                            handleSelectOperator(
                              getValue(group, field, 'originFilterFieldId'),
                              group,
                              field,
                            );
                          }}
                          showSearch
                          optionFilterProp="children"
                        >
                          {filterFields?.map(item => (
                            <Select.Group key={item.name} label={item.name}>
                              {item.filterFields.map((i: any) => {
                                return (
                                  <Select.Option key={i.id} value={i.id}>
                                    {i.friendlyFieldName}
                                  </Select.Option>
                                );
                              })}
                            </Select.Group>
                          ))}
                        </Select>
                      </Form.Item>
                      {getValue(group, field, 'originFilterFieldId') && (
                        <Form.Item
                          name={[field.name, 'assertFilterOperatorId']}
                          fieldKey={[field.fieldKey, 'assertFilterOperatorId']}
                          style={{
                            width: groupOrder === 'row' ? '33.33%' : '100%',
                          }}
                          rules={[{ required: true }]}
                        >
                          <Select onChange={handleChangeOperatorInput}>
                            {subFilter
                              ?.find(
                                a =>
                                  a.id ===
                                  getValue(group, field, 'originFilterFieldId'),
                              )
                              ?.operators?.map(operator => (
                                <Select.Option
                                  key={operator.filterOperator.id}
                                  value={operator.filterOperator.id}
                                >
                                  {operator.filterOperator.name}
                                </Select.Option>
                              ))}
                          </Select>
                        </Form.Item>
                      )}
                      {getValue(group, field, 'assertFilterOperatorId') && (
                        <Form.Item
                          name={[field.name, 'filterValue']}
                          fieldKey={[field.fieldKey, 'filterValue']}
                          style={{
                            width: groupOrder === 'row' ? '33.33%' : '100%',
                          }}
                          rules={[
                            {
                              required: !emptyOperators.includes(
                                formInstance.getFieldValue('groups')[group.name]
                                  .filtersDefinition[field.name]
                                  .assertFilterOperatorId,
                              ),
                            },
                          ]}
                        >
                          {handleField(group.name, field.name)}
                        </Form.Item>
                      )}
                      {(() => {
                        // Busca o id do campo selecionado
                        const filterFieldId = getValue(
                          group,
                          field,
                          'originFilterFieldId',
                        );
                        const filterField = subFilter.find(
                          f => f.id === filterFieldId,
                        );
                        if (!filterField) {
                          console.log(
                            '[MINMAX] filterField não encontrado para id:',
                            filterFieldId,
                          );
                          return null;
                        }
                        const { min, max } = getMinMaxByField(
                          filterField.fieldName,
                        );
                        if (min === undefined && max === undefined) {
                          console.log(
                            '[MINMAX] Nenhum valor min/max encontrado para:',
                            filterField.fieldName,
                          );
                          return null;
                        }
                        return (
                          <div
                            style={{ color: 'red', fontSize: 12, marginTop: 2 }}
                          >
                            {min !== undefined &&
                              `Min.: ${Number(min).toFixed(1)}`}{' '}
                            {min !== undefined && max !== undefined && '; '}{' '}
                            {max !== undefined &&
                              `Max: ${Number(max).toFixed(1)}`}
                          </div>
                        );
                      })()}
                      {isBeetwenConnector(group, field) &&
                        getValue(group, field, 'assertFilterOperatorId') && (
                          <>
                            <Body
                              style={{ marginLeft: '10px' }}
                              weight="medium"
                            >
                              e
                            </Body>
                            <Form.Item
                              name={[field.name, 'filterValue2']}
                              fieldKey={[field.fieldKey, 'filterValue2']}
                              style={{
                                width: groupOrder === 'row' ? '33.33%' : '100%',
                              }}
                              rules={[
                                {
                                  required: !emptyOperators.includes(
                                    formInstance.getFieldValue('groups')[
                                      group.name
                                    ].filtersDefinition[field.name]
                                      .assertFilterOperatorId,
                                  ),
                                },
                                {
                                  validator: (_, value) =>
                                    validateFields(_, {
                                      field1:
                                        formInstance.getFieldValue('groups')[
                                          group.name
                                        ].filtersDefinition[field.name]
                                          .filterValue,
                                      field2:
                                        formInstance.getFieldValue('groups')[
                                          group.name
                                        ].filtersDefinition[field.name]
                                          .filterValue2,
                                    }),
                                },
                              ]}
                            >
                              <FormInput.Number />
                            </Form.Item>
                          </>
                        )}
                      <>
                        {field?.name >= 0 && query.length > 1 && (
                          <IconWrapper>
                            <CloseOutlined
                              style={{ color: '#722ed1' }}
                              onClick={() =>
                                handleRemoveQuery(
                                  remove,
                                  field.name,
                                  getValue(group, field, 'filterKey'),
                                )
                              }
                            />
                          </IconWrapper>
                        )}
                      </>
                    </Filter02>
                  </>
                );
              })}
              <div style={{ width: '200' }}>
                <Button
                  type="link"
                  icon={<PlusOutlined style={{ color: '#722ed1' }} />}
                  size="large"
                  onClick={() => add()}
                >
                  <Body color="#722ed1" weight="medium">
                    Adicionar outro filtro
                  </Body>
                </Button>
              </div>
            </>
          );
        }}
      </Form.List>
    </Body2>
  );
};

export default Query;
